import { useContext } from 'react';
import clsx from 'clsx';
import { AText, Box, Button } from '@alf/uikit';
import { useGeneralRoutes } from '@namespace/cms';
import { useIsNavMenuVisible } from '@namespace/common';
import { LocalizedLink, useI18n } from '@namespace/i18n';
import { UserContext } from '@namespace/user';
import VerificationStatusNotification from '../VerificationStatusNotification';

import styles from './index.module.css';

const RepeatedVerificationRequiredToast = ({ onClose }) => {
  const [user] = useContext(UserContext);
  const { reverificationDueDate } = user.userOptions;
  const navMenuVisible = useIsNavMenuVisible();

  const { t, f } = useI18n();

  const DATE_FORMATS_TYPES = f.getFormats();

  const endDate = f
    .getDateTime({ date: reverificationDueDate, fromUTC: true })
    .toFormat(DATE_FORMATS_TYPES.dd_MM_yyyy);

  const { profilePage } = useGeneralRoutes();

  const message = (
    <Box align="center" justify="center" className={styles.wrapper}>
      <AText size="l" align="center">
        {t('web.notification.verification.repeated.message', [endDate])}
      </AText>
      <Button
        onClick={onClose}
        component={LocalizedLink}
        to={profilePage}
        size="s"
        intent="secondary"
        actionType="color4"
        className={styles.button}
      >
        {t('web.notification.verification.repeated.button')}
      </Button>
    </Box>
  );

  return (
    <VerificationStatusNotification
      onClose={onClose}
      message={message}
      isFullWithOnMobile={true}
      customClassName={clsx([
        styles.verificationStatusNotification,
        navMenuVisible && styles.navMenuEnabled
      ])}
    />
  );
};

export default RepeatedVerificationRequiredToast;
